module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('b', [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Born and educated in the United States, Cynthia Moss has spent the past thirty-two years in Africa studying elephants and working for their conservation. In 1972 she started the Amboseli Elephant Research Project in Kenya, which she continues to direct. She is the author of four books: "), _c('i', [_vm._v("Portraits in the Wild; Elephant Memories; Echo of the Elephants;")]), _vm._v(" and a book for children, "), _c('i', [_vm._v("Little Big Ears: The Story of Ely")]), _vm._v(". She is also the coauthor of a book entitled "), _c('i', [_vm._v("Elephant Woman: Cynthia Moss Explores the World of Elephants")]), _vm._v(". She has made three documentary films about elephants, including the award-winning "), _c('i', [_vm._v("Echo of the Elephants")]), _vm._v(". The author of numerous scientific papers as well, she is now editing a volume on the elephant research carried out in Amboseli. Moss, who works for the African Wildlife Foundation, divides her time between Amboseli and Nairobi, Kenya.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30b8bb9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Abouttheauthor.vue
// module id = 69
// module chunks = 0